<template>
  <div class="vehicle-orders">
    <div class="filter-bar" style="margin-bottom: 16px; display: flex; gap: 12px; align-items: center;">
      <el-select v-model="orderType" placeholder="订单类型" clearable size="small" style="width: 120px;" @change="loadData">
        <el-option label="全部" value="" />
        <el-option label="专线" :value="1" />
        <el-option label="包车" :value="2" />
      </el-select>
      <el-select v-model="status" placeholder="工单状态" clearable size="small" style="width: 120px;" @change="loadData">
        <el-option label="全部" value="" />
        <el-option label="已指派" :value="10" />
        <el-option label="行程中" :value="40" />
        <el-option label="已完成" :value="45" />
        <el-option label="已取消" :value="60" />
      </el-select>
    </div>
    <el-table :data="list" border size="small" v-loading="loading" style="width: 100%;">
      <el-table-column label="班次号/订单号" prop="orderNo" min-width="160" />
      <el-table-column label="订单类型" width="80">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.orderType === 1 ? 'primary' : 'success'">
            {{ row.orderType === 1 ? '专线' : '包车' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="工单状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini"
            :type="row.status === 45 ? 'success' : row.status === 60 ? 'info' : row.status === 40 ? 'warning' : ''">
            {{ row.status === 10 ? '已指派' : row.status === 40 ? '行程中' : row.status === 45 ? '已完成' : '已取消' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="司机姓名" prop="driverName" width="90" />
      <el-table-column label="司机手机" prop="driverPhone" width="120" />
      <el-table-column label="乘车人数" prop="passengerNum" width="80" />
      <el-table-column label="实收金额" width="100">
        <template slot-scope="{ row }">
          <span class="util-money">¥{{ row.realFee || '0.00' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="行程开始时间" width="130">
        <template slot-scope="{ row }">{{ row.serviceTime | filterTime }}</template>
      </el-table-column>
      <el-table-column label="完成/取消时间" width="130">
        <template slot-scope="{ row }">{{ row.finishTime | filterTime }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 12px; text-align: right;"
      background
      layout="total, prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="page"
      @current-change="onPageChange"
    />
  </div>
</template>

<script>
export default {
  name: 'vehicleOrders',
  props: {
    vehicleId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      orderType: '',
      status: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.vehicleId) return
      this.loading = true
      const { code, data, total } = await this.$axios.get('/api/v1/manage/vehicle/' + this.vehicleId + '/orders', {
        params: {
          appKey: this.$store.getters.userInfo && this.$store.getters.userInfo.appKey,
          page: this.page,
          size: this.pageSize,
          orderType: this.orderType || undefined,
          status: this.status || undefined
        }
      })
      if (code === 1) {
        this.list = data || []
        this.total = total || 0
      }
      this.loading = false
    },
    onPageChange(p) {
      this.page = p
      this.loadData()
    }
  }
}
</script>
